import * as React from "react";
import {cx} from "emotion";

import "./dedupe-modal.scss";

import {cs}                      from "@Common/react/chain-services";
import {UseState}                from "@Common/react/use-state";
import {DataTableD1}             from "@Common/ui-components/heavy/common/design2/data-table/data-table-d1";
import {PageList}                from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {PAGE_SIZE_ALL, PageSize} from "@Common/ui-components/heavy/common/design2/pagination-ui/page-size/page-size";
import {ModalService3}           from "@Common/ui-components/modal-service-3/modal-service-3";
import {sum}                     from "@Common/utils/collections";

export const DedupeModal = ({list, next: rootNext}) => cs(
    ["modal", (_, next) => ModalService3({
        title: "Duplicated Addresses",
        // initShow: isDevQuan(),
        next, rootNext,
    })],
    ({modal}) => (
        <div className="dedupe-modal dedupe-modal-4k5">
            <div className="content">
                {cs(
                    ({}, next) => (
                        <div className="dark-box">
                            {next()}
                        </div>
                    ),
                    ["rows", ({}, next) => next(list.value?.map((address, i) => ({
                        key: i,
                        columns: [
                            {
                                render: () => address.address,
                                sortValue: () => address.address,
                            },
                            {
                                render: () => address.city,
                                sortValue: () => address.city,
                            },
                            {
                                render: () => address.state,
                                sortValue: () => address.state,
                            },
                            {
                                render: () => address.zip,
                                sortValue: () => address.zip,
                            },
                            {
                                render: () => address.count,
                                sortValue: () => address.count,
                            },
                        ],
                    })))],
                    ["pageSize", (_, next) => UseState({next, getInitValue: () => 10})],
                    ({rows, pageSize}) => DataTableD1({

                        className: cx("table"),
                        // paginationKey: mailingTable.selectedOnly.value,
                        columns,
                        rows: rows,
                        emptyAction: {
                            label: list.loading ? (
                                "Loading..."
                            ) : (
                                "No duplicated addresses"
                            ),
                        },
                        pageSize: pageSize.value,
                        getFooter: ({pagination, colCount}) => ({
                            columns: [{
                                colSpan: colCount,
                                render: () => (
                                    <div className="controls">
                                        <div className="page-size">
                                            {list.value?.length > 10 && (
                                                PageSize({
                                                    state: pageSize,
                                                    extraSizes: [PAGE_SIZE_ALL],
                                                })
                                            )}
                                        </div>

                                        <div className="pagination">
                                            {pagination.active && (
                                                PageList(pagination)
                                            )}
                                        </div>

                                        <div className="count">
                                            <div className="label">
                                                Total Duplicated
                                            </div>
                                            <div className="value">
                                                {sum(list.value, (a) => a.count)}
                                            </div>
                                        </div>

                                    </div>
                                ),
                            }],
                        }),
                    }),
                )}
            </div>
            <div className="footer">
                <button
                    className="next"
                    onClick={() => modal.close()}
                >
                    Done
                </button>
            </div>
        </div>
    ),
);

const columns = [
    {
        width: "1%",
        className: "address",
        label: "ADDRESS",
        align: "left",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Address",
        },
        sortable: {
            defaultDirection: "asc",
        },
    },
    {
        width: "1%",
        className: "city",
        label: "CITY",
        align: "left",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "City",
        },
        sortable: {
            defaultDirection: "asc",
        },
    },
    {
        width: "1%",
        className: "state",
        label: "STATE",
        align: "left",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "State",
        },
        sortable: {
            defaultDirection: "asc",
        },
    },
    {
        width: "1%",
        className: "zip code",
        label: "ZIP CODE",
        align: "right",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Zip Code",
        },
        sortable: {
            defaultDirection: "asc",
        },
    },
    {
        width: "1%",
        className: "duplicates",
        label: "DUPLICATES",
        align: "right",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Duplicates",
        },
        sortable: {
            defaultDirection: "desc",
        },
    },
];

